export default "__VITE_ASSET__COorix$A__"